export function LoadingScreen({ message = 'Laster Mellomrom …' }: { message?: string }) {
  return <main className="loading-screen"><span className="brand-mark">M</span><p>{message}</p></main>;
}
